<template src="./html/MediaManager.html"></template>

<script>
	import Create from './../views/Create.vue'
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import FileSaver from 'file-saver'


	export default {
		props: ['user', 'isAuth', 'medias', 'dropzone', 'public', 'images', 'url'],
		components: {
			'media-create': Create
		},
		data () {
			return {

			}
		},
		mounted(){
		},
		methods: {
			reload(response) {
				this.$emit('reload', response)
			},
			destroy(media) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete(that.dropzone.url + '/media/' + media.id + '/destroy')
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			changePermission(media) {
				this.$http.get(this.dropzone.url + '/media/' + media.id + '/change/permissions')
				.then(response => {
					media.permissions = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			download(media) {
				var loading = Ladda.create(document.querySelector('#btn-download-media-'+media.id))
				loading.start()
				this.$http.get(this.dropzone.url + '/media/' + media.id + '/download', {responseType: 'blob'})
				.then(response => {
					loading.stop()
					var file = response.body
					var blob = new Blob([file], {type: media.mime_type});
					var file_name = media.filename + '.' + media.extension
					FileSaver.saveAs(blob, file_name);
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
			update(media) {
				var loading = Ladda.create(document.querySelector('#btn-update-'+media.id))
				loading.start()
				this.$http.put('admin/media/' + media.id, media)
				.then(response => {
					loading.stop()
					swal(response.body.title, response.body.text, response.body.type);
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
			canView(media) {
				var can = false
				if(media) {
					if(media.aggregate_type == 'pdf' || media.aggregate_type == 'image') {
						can = true
					}
				}
				return can
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/MediaManager/layout/MediaManager.vue